import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SocketContext from "../context/create-context";
import { emsPacketSocket, userEnterSocket } from "../datastore/actions";
import { Grid } from "@material-ui/core";
import { AppBar, Toolbar, Typography, Container } from "@mui/material";

import { getUser, removeUser } from "../utility/preferences";
import { Redirect } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Loader from "./loader";
import {
  Box, Paper,
  TextField,
  InputAdornment,
  SvgIcon,
  Button,
} from "@mui/material";

import { MostPower } from "./widgets/most-power";

import { TotalPower } from "./widgets/total-power";
import { WeakCellProgress } from "./widgets/weak-cell";
import { GridDuration } from "./widgets/grid-duration";
import { EMSDetailHandler, HandleEmsGrid,HandleEmsGridID } from "./widgets/handle-ems-detail";
import {
  setEMSPacket,
  loadEmsList,
  specificGraphPacket,
} from "../datastore/emslistSlice";
import backgroundImg from "../assets/energy-eco.jpg";

import { Search as SearchIcon } from "../icons/search";
const Logout = () => {
  removeUser();
  window.location.href = "/";
};

const sendMsg = (client, dispatch, emsID) => {
  let data = {
    type: "utf8",
    utf8Data: JSON.stringify({
      type: "userevent",
      username: "bilawal",
    }),
    emsID: "#",
  };
  dispatch(userEnterSocket(client, data));
};

const today = new Date();

let _map = new Map();

function formatDate(date, format) {
  let yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  return yyyy + "-" + mm + "-" + dd;
}
const isObjectEmpty = (objectName) => {
  return Object.keys(objectName).length === 0
}
const Dashboard = () => {
  const dispatch = useDispatch();
  const currentSocket = useContext(SocketContext);
  const [searchedEMS, setSearchedEMS] = useState("");
  
  const {
    emsName,
    emsArray,
    userID,
    eachEMSData,
    user,
    loading,
    emsPowerGraph,
  } = useSelector((state) => state);
  if (_map.size == 0) {
    
    emsArray.forEach((e) => {
      _map.set(e["emsID"], { id: e["id"], packet: {} });
    });
  } else if(searchedEMS.length > 0) {
    
    _map.clear();
    emsArray.forEach((e) => {
      if(e["emsID"].includes(searchedEMS)) {
        _map.set(e["emsID"], { id: e["id"], packet: {} });
      }
    });
  }

  if (eachEMSData["BatteryID"] !== undefined) {
    let emsID = eachEMSData["BatteryID"];
    if (_map.has(emsID)) {
      _map.get(emsID)["packet"] = eachEMSData;
    }
  }

  // }
  useEffect(() => {
    dispatch(loadEmsList());

    currentSocket.on("selectedEMSData", (message) => {
      let { emsID, packet } = message;
      if (emsID != "#") {
        dispatch(
          specificGraphPacket({
            emsID: emsID,
            emsPacket: JSON.parse(packet),
          })
        );
      } else {
        dispatch(setEMSPacket(JSON.parse(packet)));
       
      }
    });
  }, [dispatch]);

  if (getUser() == null) {
    return <Redirect to="/login" />;
  } else if (loading === true) {
    return <Loader />;
  } else {

    return (
      <div style={{ backgroundImage: `url(${backgroundImg})` }}>
        <Box component="main">
          <AppBar position="static">
            <Toolbar>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
              >
                <MenuIcon />
              </IconButton>

              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                {`Welcome ${getUser().username}`}             
              </Typography>

              
              <Button color="inherit" onClick={Logout}>
                Logout
              </Button>
            </Toolbar>
          </AppBar>
        </Box>
        <Container style={{ margin: "10px" }} maxWidth={false}>
          <Grid
            style={{ margin: "10px" }}
            container
            spacing={3}
            direction="column"
          >
            <Grid
            style={{ margin: "10px" }}
            container
            spacing={2}
            direction="row"
            alignItems="center"
          >
            <Grid
              style={{
                marginTop: "12px",
                maxHeight: "85vh",
                overflow: "auto",
                padding: "10px",
                margin: "10px"
              }}
              item
              xs={3}
              md={2}
            >
              <Box sx={{ width: "calc(100% - 20px)", marginBottom: "20px", padding: "10px", margin: "10px" }}>
                <Paper style={{ padding: "10px", margin: "10px" }}>
                  <TextField
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon fontSize="small" color="action">
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      ),
                    }}
                    placeholder="Search EMS"
                    variant="outlined"
                    onChange={(e) => {

                      setSearchedEMS(e.target.value);
                  }}
                  />
                </Paper>
              </Box>

              {HandleEmsGrid( _map,userID, currentSocket, dispatch)}
            </Grid>
            <Grid item>
              <EMSDetailHandler
                data={{ emsName,eachEMSData }}
              />
            </Grid>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                pt: 3,
                padding: "10px",
                margin: "10px"
              }}
            ></Box>
          </Grid>
            <Grid item>
              <Grid container spacing={1}>
                <Grid item xl={3} lg={5} sm={6} xs={8}>
                  <MostPower />
                </Grid>
                <Grid item xl={2} lg={5} sm={6} xs={8}>
                  <TotalPower />
                </Grid>
                <Grid item xl={2} lg={5} sm={6} xs={8}>
                  <GridDuration />
                </Grid>
                <Grid item xl={2} lg={5} sm={6} xs={8}>
                  <WeakCellProgress />
                </Grid>
              </Grid>
            </Grid>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                pt: 3,
                padding: "10px",
                margin: "10px"
              }}
            ></Box>
          </Grid>
        </Container>
        {/* ================================================================================ */}
      </div>
    );
  }
};

export default Dashboard;
